import NewPasswordContainer from './NewPasswordContainer';

export default NewPasswordContainer;
